import { Component, ViewEncapsulation } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { FilterOperations } from 'src/app/filters/filter-operation/filter-operations.enum';
import { getAccountPrivileges } from 'src/app/privileges/privileges.selector';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import { BlockedPhoneNumberRegister } from '../blocked-phone-number-register';
import { BlockedPhoneNumberFilterOptions } from '../models/blocked-phone-number-filter-option';
import { BlockedPhoneNumberPrivileges } from '../models/blocked-phone-number-privileges';
import * as BlockedPhoneNumberRegisterActions from '../state/blocked-phone-number-register.actions';
import { createBlockedPhoneNumber } from '../state/blocked-phone-number-register.actions';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-blocked-phone-number-register',
    styleUrls: ['./blocked-phone-number-register.component.scss'],
    templateUrl: './blocked-phone-number-register.component.html',
    standalone: false
})
export class BlockedPhoneNumberRegisterComponent extends BlockedPhoneNumberRegister {
   blockedPhoneNumberPrivileges$: Observable<BlockedPhoneNumberPrivileges>;

   constructor(public store: Store) {
      super(store);
      this.blockedPhoneNumberPrivileges$ = store.pipe(select(getAccountPrivileges));
      store
         .select(getSelectedAccountId)
         .pipe(
            filter((accountId: number | null): accountId is number => {
               return accountId != null;
            }),
            map((accountId: number) => {
               const filters: BlockedPhoneNumberFilterOptions[] = [
                  {
                     field: 'AccountId',
                     operation: FilterOperations.EqualTo,
                     type: 'numeric',
                     value: accountId,
                  },
               ];
               return filters;
            })
         )
         .subscribe((filters) => {
            this.filters = filters;
         });
      this.columns = ['phoneNumber', 'comment', 'blockedPhoneNumberActionsMenu'];
   }

   onCreate(): void {
      this.store.dispatch(createBlockedPhoneNumber());
   }

   onDeleteBlockedPhoneNumber(event: { blockedPhoneNumberId: number; phoneNumber: string }) {
      this.store.dispatch(BlockedPhoneNumberRegisterActions.deleteBlockedPhoneNumber(event));
   }
}
